import React from 'react';
import Icon from '../ui/Icon';
import Modal from '../ui/Modal';
import styles from './PhonePreview.module.css';

// Exported so Sms/Whatsapp/Rcs previews (which reuse this file's .phone/
// .notch/.time frame styles directly) size their own enlarge scaling off the
// same numbers instead of a second hardcoded copy that could drift.
export const PHONE_W = 240;
export const PHONE_H = 520;
export const PHONE_LARGE_SCALE = 2;

// The notification card itself — shared between the small inline preview and
// the enlarged modal version, so the two can never drift out of sync.
function Notif({ title, body }) {
  return (
    <div className={styles.notif}>
      <div className={styles.ico}>P</div>
      <div className={styles.content}>
        <div className={styles.title}>{title || 'Your campaign title'}</div>
        <div className={styles.body}>{body || 'Your message body appears here…'}</div>
        <div className={styles.meta}>now · PMW Click</div>
      </div>
    </div>
  );
}

function Frame({ title, body, scale = 1 }) {
  return (
    <div style={{ width: PHONE_W * scale, height: PHONE_H * scale }}>
      <div className={styles.phone} style={scale !== 1 ? { transform: `scale(${scale})`, transformOrigin: 'top left' } : undefined}>
        <div className={styles.notch} />
        <div className={styles.time}>9:41</div>
        <Notif title={title} body={body} />
      </div>
    </div>
  );
}

class PhonePreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  render() {
    const { title, body } = this.props;
    const { expanded } = this.state;
    return (
      <div className={styles.wrap}>
        <div className={styles.labelRow}>
          <span className={styles.label}>Live Preview</span>
          <button type="button" className={styles.expandBtn} title="Enlarge preview" onClick={() => this.setState({ expanded: true })}>
            <Icon name="open_in_full" size={11} />
          </button>
        </div>
        <Frame title={title} body={body} />
        <div className={styles.caption}>Android lock screen · preview only</div>

        <Modal open={expanded} onClose={() => this.setState({ expanded: false })} title="Push — full preview" width="fit-content">
          <Frame title={title} body={body} scale={PHONE_LARGE_SCALE} />
        </Modal>
      </div>
    );
  }
}

export default PhonePreview;
